import * as React from 'react';
import { css } from '@emotion/core';
import Select, { Props } from 'react-select/creatable';

const selectorCss = css`flex-grow: 2`;

const produceOption = (value: string) => ({ label: value, value });

type Modify<T, R> = Omit<T, keyof R> & R;

export type SelectorProps = Modify<Props<{ label: string; value: string }>, {
  options: string[];
  onChange: (value: string) => void;
  value: string;
}>;

function Selector(props: SelectorProps) {
  const {
    value,
    options,
    onChange,
    ...rest
  } = props;

  const handleChange = React.useCallback((option: { label: string; value: string; }) => {
    onChange(option.value);
  }, [onChange]);

  const selectValue = React.useMemo(() => {
    if (!value) {
      return undefined;
    }

    return produceOption(value as string);
  }, [value]);

  const selectOptions = React.useMemo(() => options.map(produceOption), [options]);

  return (
    <Select
      isCreatable
      options={selectOptions}
      value={selectValue}
      css={selectorCss}
      onChange={handleChange}
      {...rest}
    />
  );
}

export default React.memo(Selector);
